module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-144x144-2f83a9c33daf78ab1f49b6cdaeeaf0ed.png";